import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";

import "./header.css";


function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return <div className={`header ${isScrolled ? "shrink" : ""}`}>

        <div className="logo"></div>

        <p>
            Tanz- und Bewegungstherapie<br/>
            Psychotherapeutische Praxis
        </p>
        <h1>Solveig Marita Bissinger</h1>

        <button className="burger" onClick={() => setIsOpen(!isOpen)}>
            <div/>
            <div/>
            <div/>
        </button>

        <nav className={`${isOpen ? "open" : ""}`}>
            
                <NavLink exact to="/" onClick={() => setIsOpen(false)}>Home</NavLink>
                <NavLink to="/tanztherapie" onClick={() => setIsOpen(false)}>Tanztherapie</NavLink>
                <NavLink to="www.solveig-bissinger.de" onClick={() => setIsOpen(false)}>Kreativer Tanz ↗</NavLink>
                <NavLink to="/ueber" onClick={() => setIsOpen(false)}>Über Mich</NavLink>
                <NavLink to="/kontakt" onClick={() => setIsOpen(false)}>Kontakt</NavLink>
            
        </nav>
    </div>
}

export default Header;